import s from './Header.module.css';
import type { IRoadmap } from '../data/types';
import { countAggregates, getOverallProgress } from '../utils/progress';

interface IHeaderProps {
  roadmap: IRoadmap;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onReset: () => void;
}

const ZoomIn = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="11" cy="11" r="7" />
    <path d="M11 8v6M8 11h6M21 21l-4.35-4.35" strokeLinecap="round" />
  </svg>
);

const ZoomOut = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="11" cy="11" r="7" />
    <path d="M8 11h6M21 21l-4.35-4.35" strokeLinecap="round" />
  </svg>
);

const Reset = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M3 12a9 9 0 1 0 3-6.7L3 8" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M3 3v5h5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const Header = ({ roadmap, onZoomIn, onZoomOut, onReset }: IHeaderProps) => {
  const progress = getOverallProgress(roadmap);
  const aggregates = countAggregates(roadmap);

  return (
    <header className={s.header}>
      <div className={s.brand} style={{ pointerEvents: 'auto' }}>
        <div className={s.logo} aria-hidden="true">
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            strokeWidth="2.4"
          >
            <path
              d="M12 2v6M12 22v-6M2 12h6M22 12h-6M5 5l3.5 3.5M19 19l-3.5-3.5M5 19l3.5-3.5M19 5l-3.5 3.5"
              strokeLinecap="round"
            />
          </svg>
        </div>
        <div className={s.title}>
          <span className={s.titleMain}>LUCKIFY · Карта развития</span>
          <span className={s.titleSub}>обновлено {roadmap.meta.updatedAt}</span>
        </div>
      </div>

      <div className={s.metrics}>
        <div className={s.metric}>
          <span className={s.metricLabel}>Прогресс</span>
          <span className={`${s.metricValue} ${s.metricAccent}`}>{progress.percent}%</span>
        </div>
        <div className={s.metric}>
          <span className={s.metricLabel}>Задач</span>
          <span className={s.metricValue}>
            {aggregates.doneTasks}/{aggregates.tasks}
          </span>
        </div>
        <div className={s.metric}>
          <span className={s.metricLabel}>Экранов</span>
          <span className={s.metricValue}>{aggregates.pages}</span>
        </div>
        <div className={s.metric}>
          <span className={s.metricLabel}>Направлений</span>
          <span className={s.metricValue}>{roadmap.phases.length}</span>
        </div>
      </div>

      <div className={s.controls}>
        <button
          type="button"
          className={s.controlBtn}
          onClick={onZoomOut}
          aria-label="Уменьшить"
          title="Уменьшить"
        >
          <ZoomOut />
        </button>
        <button
          type="button"
          className={s.controlBtn}
          onClick={onZoomIn}
          aria-label="Увеличить"
          title="Увеличить"
        >
          <ZoomIn />
        </button>
        <button
          type="button"
          className={s.controlBtn}
          onClick={onReset}
          aria-label="Сбросить вид"
          title="Сбросить вид"
        >
          <Reset />
        </button>
      </div>
    </header>
  );
};
